import { makeStyles } from 'tss-react/mui';

const useStylesTableRowNoContent: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableRowNoContent: {
    cursor: 'default !important',
    background: `${theme.palette.common.white} !important`,
    '& > td': {
      border: 'none !important',
      background: `${theme.palette.common.white} !important`,
      fontWeight: 'normal !important',
      padding: '15px 12px !important',
      [theme.breakpoints.down('md')]: {
        padding: '15px 25px',
      },
    },
  },
}));

export default useStylesTableRowNoContent;
